import { http } from '@/lib/apiClient';
import type {
  CreateCategoriaInput,
  Operatore,
  OperatoreCategoria,
  TicketCategoria,
  UpdateCategoriaInput,
  UUID,
} from '@/types';

const BASE = '/ticket-categorie';

export const categorieService = {
  list(includeInactive = false): Promise<TicketCategoria[]> {
    return http.get<TicketCategoria[]>(BASE, {
      params: includeInactive ? { includeInactive: true } : undefined,
    });
  },

  create(input: CreateCategoriaInput): Promise<TicketCategoria> {
    return http.post<TicketCategoria, CreateCategoriaInput>(BASE, input);
  },

  update(id: UUID, input: UpdateCategoriaInput): Promise<TicketCategoria> {
    return http.patch<TicketCategoria, UpdateCategoriaInput>(`${BASE}/${id}`, input);
  },

  deactivate(id: UUID): Promise<TicketCategoria> {
    return http.delete<TicketCategoria>(`${BASE}/${id}`);
  },
};

export const operatoriService = {
  list(categoriaId?: UUID): Promise<Operatore[]> {
    return http.get<Operatore[]>('/operatori', {
      params: categoriaId ? { categoria_id: categoriaId } : undefined,
    });
  },

  listCategorie(utenteId: UUID): Promise<OperatoreCategoria[]> {
    return http.get<OperatoreCategoria[]>(`/operatori/${utenteId}/categorie`);
  },

  replaceCategorie(utenteId: UUID, categoriaIds: UUID[]): Promise<OperatoreCategoria[]> {
    return http.put<OperatoreCategoria[], { categoria_ids: UUID[] }>(`/operatori/${utenteId}/categorie`, {
      categoria_ids: categoriaIds,
    });
  },

  patchCategoria(utenteId: UUID, categoriaId: UUID, abilitato: boolean): Promise<OperatoreCategoria[]> {
    return http.patch<OperatoreCategoria[], { abilitato: boolean }>(
      `/operatori/${utenteId}/categorie/${categoriaId}`,
      { abilitato },
    );
  },

  myCategorie(): Promise<OperatoreCategoria[]> {
    return http.get<OperatoreCategoria[]>('/me/categorie');
  },
};
